module.exports = __webpack_public_path__ + "static/img/2.e8b99c93.jpg";